module.exports = __webpack_public_path__ + "img/title-bg.cd169b74.png";